import { PAGES } from "@/common/consts";

export const pageIndex = {
	[PAGES.HOME]: "/",
	[PAGES.FOURPICS]: "/4pics1word/",
	[PAGES.ANAGRAM]: "/anagram-solver",
	[PAGES.WORD_DESCRAMBLER]: "/word-descrambler",
	[PAGES.WORDBRAIN_ANSWERS]: "/wordbrain-answers",
	[PAGES.TEXT_TWIST]: "/text-twist",
	[PAGES.SCRABBLE_CHECKER]: "/scrabble-checker",
	[PAGES.JUMBLE_SOLVER]: "/jumble-solver",
	[PAGES.SCRABBLE_DICT]: "/scrabble-dictionary",
	[PAGES.WORD_CHUMS_CHEAT]: "/word-chums-cheat",
	[PAGES.UNSCRAMBLE]: "/unscramble",
	[PAGES.WORDCOOKIES]: "/word-cookies",
	[PAGES.WORDFEUD]: "/wordfeud-helper",
	[PAGES.WORD_MAKER]: "/word-maker",
	[PAGES.WWF]: "/words-with-friends-cheat",
	[PAGES.LETTERS_AND_BLANK]: "/words-with-letters-blank",
	[PAGES.WORD_SWIPE_CHEATS]: "/word-swipe-cheats",
	[PAGES.WORD_CONNECT]: "/word-connect-answers",
	[PAGES.CODY_CROSS]: "/codycross-answers",
	[PAGES.WORD_STORY]: "/words-story-answers",
	[PAGES.WORD_SCRAMBLE]: "/word-scramble/",
	[PAGES.WORDLE]: "/wordle/",
	[PAGES.QUORDLE]: "/quordle/",
};

const template = () =>
	import(
		/* webpackChunkName: "template-game-page" */ "@/pages/template-game-page"
	);

const generateGamePagesConfig = () => {
	return Object.entries(pageIndex).map(([routeName, path]) => ({
		path,
		name: routeName,
		component: template,
	}));
};

export const pageRoutes = generateGamePagesConfig();
